const LOGIN_MENU_ACTIVE_CLASS = 'login-menu--is-active';

const LOGIN_MENU_BUTTON_HOOK = '[js-hook-login-menu-button]';
const LOGIN_MENU_HOOK = '[js-hook-login-nav]';

class LoginNav {
    constructor(element) {
        this.element = element;
        this.loginMenuButtons = [...this.element.querySelectorAll(LOGIN_MENU_BUTTON_HOOK)];
        this.loginMenu = this.element.querySelector(LOGIN_MENU_HOOK);

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.loginMenuButtons.forEach(button => {
            button.addEventListener('click', () => {
                if (window.outerWidth < 1250) {
                    this.loginMenu.classList.toggle(LOGIN_MENU_ACTIVE_CLASS);
                }
            });
        });
    }
}

export default LoginNav;
